import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '#app/hooks/useAppStore';
import { SmallImage } from './styles';

const SmallProfileImage = ({ showAvatarModal }) => {
  const navigate = useNavigate();
  const avatar = useAppSelector((state) => state.scenario.avatar);
  const client = useAppSelector((state) => state.interfaceComponents.client);
  const [loaded, setLoaded] = useState(false);
  const showPhotoIcon = false;

  const getAvatarPath = () => avatar;

  return (
    <SmallImage>
      <div
        className="avatar"
        onClick={() => {
          if (typeof showAvatarModal === 'function') {
            showAvatarModal();
          } else {
            navigate('/cabinet/register/page1');
          }
        }}
      >
        {!!avatar && (
          <img
            id="avatar"
            className="avatar"
            style={loaded ? {} : { display: 'none' }}
            alt=""
            src={getAvatarPath()}
            onLoad={() => setLoaded(true)}
          />
        )}
        <div
          className="icon"
          style={{
            display: showPhotoIcon ? 'block' : 'none',
          }}
        >
          <img className="icon" src={require('./images/photo.png')} alt="" />
        </div>
      </div>
      <div id="user-hidden-id" style={{ display: 'none' }}>
        {client ? client.id : ''}
      </div>
    </SmallImage>
  );
};

export default SmallProfileImage;
